import { CommonModule } from '@angular/common';
import { Component, inject, OnInit, signal } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { UserService } from '../../../core/services/user.service';
import { NotificationService } from '../../../core/services/notification.service';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { PASSWORD_PATTERN } from '../../../core/constants/regex.constants';
import { PasswordStrengthComponent } from '../../../shared/components/password-strength/password-strength.component';
import { MatSelectModule } from '@angular/material/select';

@Component({
  selector: 'app-change-password',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatProgressSpinner,
    PasswordStrengthComponent,
    MatSelectModule,
  ],
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss'],
})
export class ChangePasswordComponent implements OnInit {
  private fb = inject(FormBuilder);
  private user = inject(UserService);
  private notify = inject(NotificationService);
  private dialogRef = inject(MatDialogRef<ChangePasswordComponent>);
  data = inject(MAT_DIALOG_DATA);

  form!: FormGroup;
  showPassword = signal(false);
  showOldPassword = signal(false);
  loading = signal(false);
  submitted = signal(false);
  showConfirmPassword = signal(false);

  ngOnInit() {
    // this.setFormStructure(this.data.field);
    this.form = this.fb.group({
        oldPassword: ['', Validators.required],
        newPassword: ['', [
        Validators.required,
        Validators.minLength(13),
        Validators.pattern(PASSWORD_PATTERN)
        ]],
        confirmPassword: ['', [
        Validators.required,
        Validators.minLength(13)
        ]],
    },{
        validators: this.passwordsMatchValidator
    });
    // this.setFieldConfig(this.data.field);
  }

//   private setFieldConfig(field: string) {
//     switch (field) {
//       case 'verify-otp':
//         this.title = 'Otp Verification';
//         this.fieldType = '';
//         break;
//       case 'password':
//         this.title = 'Change Password';
//         this.fieldType = 'password';
//         break;
//       default:
//         this.title = 'Edit Field';
//         break;
//     }
//   }

  private setFormStructure(field: string) {
    switch (field) {
      case 'verify-otp':
        this.form = this.fb.group({
          otp: [''],
        });
        break;

      case 'password':
        
        break;

      default:
        this.form = this.fb.group({
          value: [this.data.value || '', Validators.required],
        });
        break;
    }
  }

  submit() {
    if (!this.form.valid) return;

      const { oldPassword, newPassword, confirmPassword } = this.form.value;
      if (newPassword === oldPassword) {
        this.notify.error('New password cannot be the same as the current password.');
        return;
      }
      if (newPassword !== confirmPassword) {
        this.notify.error('Passwords do not match');
        return;
      }
      this.loading.set(true);
      this.user.updatePassword(oldPassword, newPassword).subscribe({
        next: (res) => {
          this.loading.set(false);
          if (res.isSuccess) {
            this.notify.success(res.message || 'Password updated successfully');
            this.dialogRef.close(newPassword);
          } else {
            this.notify.error(res.message || 'Failed to update password');
          }
        },
        error: (err) => {
          this.loading.set(false);
          this.notify.error(err?.error?.message ||'Something went wrong while updating password');
        },
      });
      return;
    }

  closeDialog() {
    this.dialogRef.close();
  }
  passwordsMatchValidator(group: FormGroup) {
    const oldPassword = group.get('oldPassword');
    const newPassword = group.get('newPassword');
    const confirmPassword = group.get('confirmPassword');
    if (!oldPassword || !newPassword || !confirmPassword) return null;

    if (newPassword.value !== confirmPassword.value) {
      return { mismatch: true };
    }

    if (oldPassword.value && newPassword.value === oldPassword.value) {
      return { sameAsOld: true };
    }
    return null;
  }

  togglePassword(): void {
    this.showPassword.set(!this.showPassword());
  }

  toggleConfirmPassword(): void {
    this.showConfirmPassword.set(!this.showConfirmPassword());
  }

  toggleOldPassword(): void {
    this.showOldPassword.set(!this.showOldPassword());
  }
}